export default __webpack_public_path__ + "static/yt_logo_mono_light-4171286fd0dcd681ec1a14c83355723b.png";